import deviceSizes from 'constants/deviceSizes';
import useWindowSize from 'hooks/useWindowSize';
import React, { useCallback, useState } from 'react';

import LeftColumn from './components/LeftColumn';
import RightColumn from './components/RightColumn';
import { IAssignLocationRoleForm } from './types';

const AssignLocationRoleForm: React.FC<IAssignLocationRoleForm> = ({
  leftProps,
  rightProps,
  style = {},
  minimizeThreshold = deviceSizes.numbers.md,
  className,
}) => {
  const [showLeftHideRight, setShowLeftHideRight] = useState(true);
  const { isMobile } = useWindowSize(minimizeThreshold || deviceSizes.numbers.md);

  const setShowLeftHideRightCall = useCallback(() => {
    setShowLeftHideRight(true);
  }, []);
  const setShowRightHideLeftCall = useCallback(() => {
    setShowLeftHideRight(false);
  }, []);

  return (
    <div className={`flex ${className || ''} two-column-form`} style={{ height: 500, ...style }}>
      <LeftColumn
        onTitleButtonClick={setShowRightHideLeftCall}
        hidden={!showLeftHideRight}
        isMobile={isMobile}
        {...leftProps}
      />
      <RightColumn
        onTitleButtonClick={setShowLeftHideRightCall}
        hidden={showLeftHideRight}
        isMobile={isMobile}
        {...rightProps}
      />
    </div>
  );
};

export default React.memo(AssignLocationRoleForm);
